import { Avatar, Collapse, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import Icon from "@mui/material/Icon";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExpandMore from "@mui/icons-material/ExpandMore";
import axios from "axios";
import * as React from "react";
import CustomScroll from "react-customscroll";
import { withRouter } from "react-router-dom";

import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

const CustomScrollWrapped: any = CustomScroll;

class SideMenuMain extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            jobs: false,
            items: false,
            leagues: false,
            families: false,
            list: [],
        };
    }

    componentDidMount() {
        axios.get(`${Config.getInstance.apiUrl}/api/dashboard/menu`, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        })
        .then(response => {
            const list = response.data?.items || [];
            this.setState({ list: [...list] });
        })
        .catch(_ => {
            PopupMessage.error("couldn't load menu");
        });
    }

    componentWillReceiveProps(props) {
        // Close all submenus if using prod environment
        if (props.activeEnv === "prod") {
            this.setState({
                jobs: false,
                items: false,
                leagues: false,
                families: false,
            });
        }
    }

    redirectTo = (path: string) => {
        if (path.indexOf("http") > -1) {
            const win = window.open(path, "_blank");

            if (win) {
                win.focus();
            }

            return;
        }

        this.props.history.push(path);
    };

    /** Sync sidebar highlight with react-router location (withRouter). */
    isDashboardSelected(): boolean {
        const path = this.props.location?.pathname || "";
        return path === "/" || path === "";
    }

    isMenuUrlActive(menuUrl: string): boolean {
        if (!menuUrl || menuUrl.indexOf("http") > -1) {
            return false;
        }
        const path = this.props.location?.pathname || "";
        if (path === menuUrl) {
            return true;
        }
        if (menuUrl !== "/" && path.startsWith(`${menuUrl}/`)) {
            return true;
        }
        return false;
    }

    isOpen = (type) => this.state[type];

    handleCollapse = (type: string) => {
        this.setState({
            [type]: !this.state[type],
        });
    }

    renderMenuItem(item): any {
        if (item.children.length > 0) {
            return <React.Fragment key={item.id}>
                <ListItem button onClick={() => this.handleCollapse(item.id)} key={item.id} className="menu-item">
                    <ListItemIcon>
                        <Icon className={item.icon}>{item.icon}</Icon>
                    </ListItemIcon>
                    <ListItemText primary={item.name}/>
                    {this.isOpen(item.id) ? <ExpandMore/> : <ChevronRightIcon/>}
                </ListItem>

                <Collapse in={this.isOpen(item.id)} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {item.children.map(childrenItem => this.renderMenuItem(childrenItem))}
                    </List>
                </Collapse>
            </React.Fragment>
        } else {
            return <ListItem
                button
                selected={this.isMenuUrlActive(item.url)}
                onClick={() => this.redirectTo(item.url)}
                key={item.id}
                className="menu-item"
            >
                <ListItemIcon>
                    <Icon className={item.icon}>{item.icon}</Icon>
                </ListItemIcon>
                <ListItemText primary={item.name} />
            </ListItem>
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="sidebar-headingWrapper">
                    <Avatar src={require(`../../../assets/images/icons/${Config.getInstance.getSettingByKey("SITE_LOGO")}`).default}/>
                    <div style={{ marginLeft: 10 }}>
                        <Typography variant="h6">
                            {Config.getInstance.getSettingByKey("SITE_NAME")}
                        </Typography>
                        <Typography variant="body2" component="p" color="textSecondary">
                            {Config.getInstance.environment}
                        </Typography>
                    </div>
                </div>

                <CustomScrollWrapped>
                    <List>
                        <ListItem
                            button
                            className="menu-item"
                            selected={this.isDashboardSelected()}
                            onClick={() => this.redirectTo("/")}
                        >
                            <ListItemIcon><DashboardIcon/></ListItemIcon>
                            <ListItemText primary="Dashboard"/>
                        </ListItem>

                        {this.state.list.map(item => this.renderMenuItem(item))}
                    </List>
                </CustomScrollWrapped>
            </React.Fragment>
        );
    }
}

export const SideMenu = withRouter(SideMenuMain);
